/* eslint-disable */
import React, { useState, useRef, useEffect } from "react";
import { getClaims } from "../../../actions";
import Scrollbars from "react-custom-scrollbars";
import moment from "moment";
import { connect } from "react-redux";
import Statistics from "../../Statistics";

const headerElements = [
  {
    name: "User",
    query: { filter: "Date", options: [] },
  },
  {
    name: "Phone",
    query: { filter: "Time", options: [] },
  },
  {
    name: "Claim report date",
    query: { filter: "Invitation sent by", options: [] },
  },
  {
    name: "Insurance company",
    query: { filter: "Role", options: [] },
  },
  {
    name: "Claim status date",
    query: { filter: "Invitation sent by", options: [] },
  },
  {
    name: "Claim number",
    query: { filter: "Role", options: [] },
  },
  {
    name: "Completed",
    query: { filter: "Invitation sent by", options: [] },
  },
];

const Claims = ({ getClaims, claims, period, loading, setLoading, filtered }) => {
  const [curPage, setCurPage] = useState(2);
  const tableRef = useRef();
  const [innerLoading, setInnerLoading] = useState(false);

  const handleUpdate = (values) => {
    const { scrollTop, scrollHeight, clientHeight } = values; //get elements from object
    const pad = 0; // how much px from bottom
    const t = (Math.round(scrollTop) + pad) / (scrollHeight - clientHeight); // must be at least 1.0
    if (t >= 0.97 && claims.totalPages >= curPage && !innerLoading) {
      setInnerLoading(true);
      getClaims({
        pageNumber: curPage,
        limit: 20,
        ...period,
        createdAtFrom: period?.createdAtFrom || moment("2020-07-21").startOf("day").toISOString(),
        onSuccess: (res) => setInnerLoading(false),
      });
      setCurPage(curPage + 1);
    }
  };
  useEffect(() => {
    getClaims({
      pageNumber: 1,
      limit: 20,
      ...period,
      createdAtFrom: period?.createdAtFrom || moment("2020-07-21").startOf("day").toISOString(),
      onSuccess: (res) => {
        setLoading(false);
      },
    });
    setCurPage(2);
  }, []);

  useEffect(() => {
    if (filtered)
      getClaims({
        pageNumber: 1,
        limit: 20,
        ...period,
        createdAtFrom: period?.createdAtFrom || moment("2020-07-21").startOf("day").toISOString(),
        onSuccess: (res) => {
          setLoading(false);
          setCurPage(2);
        },
      });
  }, [period, filtered]);

  return (
    <>
      {loading === true ? (
        <div style={{ height: "90%" }}>{<Statistics.LoaderInline center />}</div>
      ) : (
        <>
          <h2 style={{ marginBottom: "20px", textTransform: "uppercase" }}>users with claims</h2>
          <Scrollbars style={{ height: "92%", width: "100%" }} onUpdate={handleUpdate} ref={tableRef} id={"scrollbar"} renderView={(props) => <div {...props} style={{ ...props.style, overflowX: "hidden" }} />}>
            <div className="table-header">
              {headerElements?.map((header, i) => {
                return (
                  <div
                    className="header-cont"
                    key={i}
                    style={{
                      width: "12%",
                    }}
                  >
                    <div className="header">{header.name}</div>
                  </div>
                );
              })}
            </div>
            {claims?.docs?.map((claim, i) => {
              return (
                <div className="table-body-row" key={i}>
                  <div className="row-data" style={{ width: "12%" }}>
                    {claim?.fullName || "---"}
                  </div>
                  <div className="row-data" style={{ width: "12%" }}>
                    {claim?.phoneNumber || "---"}
                  </div>
                  <div className="row-data" style={{ width: "12%" }}>
                    {moment(claim?.accidentOccurred).format("DD.MM.YYYY") || "---"}
                  </div>
                  <div className="row-data" style={{ width: "12%" }}>
                    {claim?.insuranceAgency || "---"}
                  </div>
                  <div className="row-data" style={{ width: "12%" }}>
                    {moment(claim?.updatedAt).format("DD.MM.YYYY") || "---"}
                  </div>
                  <div className="row-data" style={{ width: "12%" }}>
                    {claim?.claimNumber || "---"}
                  </div>
                  <div className="row-data" style={{ width: "12%" }}>
                    ---
                  </div>
                </div>
              );
            })}
            {innerLoading && (
              <div className="inner-loader-container">
                <Statistics.LoaderInline center />
              </div>
            )}
          </Scrollbars>
        </>
      )}
    </>
  );
};
const mapStateToProps = (state) => ({
  claims: state.app.claims,
});
const mapDispatchToProps = (dispatch) => ({
  getClaims: (payload) => dispatch(getClaims(payload)),
});
export default connect(mapStateToProps, mapDispatchToProps)(Claims);
